<template>
    <div id="GeNumber">
        <h1>Gefahrgutnummer</h1>
    </div>
</template>